import { useEffect, useState } from "react";

/**
 * A key that changes once the window has stopped changing size (debounced).
 *
 * react-big-calendar 1.8.4's month view measures how many items fit in a day
 * only when it mounts: its resize listener asks for a new measurement, but
 * the view's getDerivedStateFromProps resets that request on the next render
 * (it only re-measures when the month changes). So after shrinking the window
 * items spilled out of the cells and "+N more" disappeared until a reload
 * (QA C5). Giving the calendar this key remounts it, which measures again.
 */
export const useResizeKey = (delayMs = 250) => {
  const [key, setKey] = useState(0);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    const onResize = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => setKey((value) => value + 1), delayMs);
    };
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      if (timer) clearTimeout(timer);
    };
  }, [delayMs]);

  return key;
};
